import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { useRltWorkOrderUpdateStateMutation } from "@/services/backend/rlt/work-orders/api/work-order-api";

export function CancelWorkOrderDialog({ workOrder }: { workOrder: WorkOrder }) {
  const [patch, { isLoading, error }] = useRltWorkOrderUpdateStateMutation();

  const doForward = () => {
    if (isLoading) return;

    patch({
      id: workOrder.id,
      state: FulfillmentState.Cancelled,
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary">{t("Stornieren")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Arbeitsschein stornieren?")}</DialogTitle>
          <DialogDescription>
            {t(
              "Der Arbeitsschein wird als storniert markiert. Er wird dann nicht mehr in der Planung oder Ausführung angezeigt.",
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doForward} />
      </DialogContent>
    </Dialog>
  );
}
